export default __webpack_public_path__ + "fa-thin-100.ttf";